import { render, staticRenderFns } from "./CustomDialogShowDetail.vue?vue&type=template&id=2e91a0bc&scoped=true&"
import script from "./CustomDialogShowDetail.vue?vue&type=script&lang=js&"
export * from "./CustomDialogShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialogShowDetail.vue?vue&type=style&index=0&id=2e91a0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91a0bc",
  null
  
)

export default component.exports